import { toast } from "sonner";
import axios from "axios";
import { useLenis } from "../lib/useLenis";
import { useTrackVisit } from "../lib/useTrackVisit";
import { useLanguage } from "../i18n/LanguageContext";
import { googlePlayUrl } from "../data/staticData";
import { Navbar } from "../components/Navbar";
import { Hero } from "../components/Hero";
import { LiveDemo } from "../components/LiveDemo";
import { SignalsMarquee } from "../components/SignalsMarquee";
import { Features } from "../components/Features";
import { HowItWorks } from "../components/HowItWorks";
import { ReportPreview } from "../components/ReportPreview";
import { UseCases } from "../components/UseCases";
import { Pricing } from "../components/Pricing";
import { FAQ } from "../components/FAQ";
import { FinalCTA } from "../components/FinalCTA";
import { Footer } from "../components/Footer";
import { StickyMobileCTA } from "../components/StickyMobileCTA";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function Landing() {
  const { t, language } = useLanguage();
  useLenis();
  useTrackVisit();

  const handlePrimaryCta = (source) => {
    axios
      .post(`${API}/analytics/track`, { language, page: source, event_type: "google_play_click" })
      .catch(() => {});
    if (typeof window.gtag === "function") {
      window.gtag("event", "click_google_play", { event_label: source });
      window.gtag("event", "conversion", {
        send_to: "AW-18336793323/DA7lCPG6vPMcEOuF1adE",
        value: 1.0,
        currency: "USD",
      });
    }
    if (typeof window.fbq === "function") {
      window.fbq("track", "Lead", { content_name: "google_play_cta", content_category: source });
    }
    if (googlePlayUrl) {
      window.open(googlePlayUrl, "_blank", "noopener,noreferrer");
    } else {
      toast(t.site.comingSoonToast);
    }
  };

  return (
    <>
      <div className="noise-overlay" />
      <Navbar onOpenDemo={() => handlePrimaryCta("navbar")} />
      <main>
        <Hero onOpenDemo={() => handlePrimaryCta("hero")} />
        <LiveDemo />
        <SignalsMarquee />
        <Features />
        <HowItWorks />
        <ReportPreview />
        <UseCases />
        {/* Testimonials hidden until production launch — will use real customer reviews */}
        <Pricing onPrimaryCta={() => handlePrimaryCta("pricing")} />
        <FAQ />
        <FinalCTA onOpenDemo={() => handlePrimaryCta("final_cta")} />
      </main>
      <Footer />
      <StickyMobileCTA onOpenDemo={() => handlePrimaryCta("sticky_mobile")} />
    </>
  );
}
